import { CONTACT, NAV } from "./data";

export const Footer = () => (
  <footer className="bg-ink text-paper" data-testid="footer">
    <div className="container-site grid gap-10 py-14 md:grid-cols-12 md:py-20">
      <div className="md:col-span-5">
        <img
          src="/images/folkare-logo.webp"
          alt="Folkare Bygg"
          width="320"
          height="129"
          className="h-[52px] w-auto"
        />
        <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#B9C1BC]">
          Byggföretag i Folkarebygden, Avesta. Sedan 2008.
        </p>
        <p className="mt-2 text-sm text-[#B9C1BC]">F-skatt · Ansvarsförsäkring</p>
        <p className="mt-1 text-sm text-[#B9C1BC]">Org.nr {CONTACT.orgNumber}</p>
      </div>

      <div className="text-sm md:col-span-4">
        <p className="font-semibold">{CONTACT.name}</p>
        <p className="mt-3">
          <a href={CONTACT.phoneHref} className="link-underline" data-testid="footer-phone-link">
            {CONTACT.phone}
          </a>
        </p>
        <p className="mt-1">
          <a href={CONTACT.emailHref} className="link-underline" data-testid="footer-email-link">
            {CONTACT.email}
          </a>
        </p>
      </div>

      <nav aria-label="Sidfot" className="text-sm md:col-span-3">
        <ul className="space-y-2">
          {NAV.map((n) => (
            <li key={n.id}>
              <a
                href={`#${n.id}`}
                className="link-underline text-[#DCE1DE]"
                data-testid={`footer-link-${n.id}`}
              >
                {n.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </div>

    <div className="border-t border-paper/15">
      <div className="container-site flex flex-col gap-2 py-6 text-xs text-[#9AA39E] sm:flex-row sm:items-center sm:justify-between">
        <p>
          © {new Date().getFullYear()} Folkare Bygg · Org.nr {CONTACT.orgNumber}
        </p>
        <p>
          Hemsida skapad av{" "}
          <a
            href="https://elido.nu/"
            target="_blank"
            rel="noopener noreferrer"
            className="link-underline text-paper/85"
          >
            Elido
          </a>
          .
        </p>
      </div>
    </div>
  </footer>
);
